import type { ReactNode } from 'react';

interface CarryStructureMapProps {
  stak: ReactNode;
  holdings: ReactNode;
  cooperative: ReactNode;
  funds: ReactNode;
}

function Connector() {
  return <div className="mx-auto h-7 w-px bg-border" />;
}

export function CarryStructureMap({
  stak,
  holdings,
  cooperative,
  funds,
}: CarryStructureMapProps) {
  return (
    <div>
      <div className="flex flex-wrap items-stretch gap-6">
        {stak}
        <div className="min-w-[330px] flex-1">{holdings}</div>
      </div>
      <Connector />
      <div className="flex justify-center">{cooperative}</div>
      <Connector />
      {funds}
    </div>
  );
}
